import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { FormControl } from '@angular/forms';
import { take, takeUntil } from 'rxjs/operators';
import { ReplaySubject, Subject } from 'rxjs';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { OrderPipe } from 'ngx-order-pipe';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { FieldResource, PossibleValueResource } from '../../core/modules/openapi';

@Component({
  selector: "app-select-search",
  imports: [MatFormFieldModule, MatSelectModule, ReactiveFormsModule, CommonModule],
  template: `
    <mat-form-field [formGroup]="group">
      <mat-select [placeholder]="field.displayName" [formControlName]="field.name"
                  [multiple]="field.multiple" #singleSelect>
        <mat-option>
          <ngx-mat-select-search [formControl]="filterCtrl" placeholderLabel="Search..."
                                 noEntriesFoundLabel="No matching item found"></ngx-mat-select-search>
        </mat-option>
        <mat-option *ngFor="let item of filteredValues | async"
                    [value]="item.value">{{ item.name }}
        </mat-option>
      </mat-select>
      <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error
          *ngIf="group.controls[field.name].hasError(validation.name.toLowerCase())">{{ validation.message }}
        </mat-error>
      </ng-container>
    </mat-form-field>
  `,
  standalone: true,
  styleUrls: ['./select-search.component.css']
})
export class SelectSearchComponent implements OnInit, OnDestroy {
  field: FieldResource;
  group: FormGroup;
  /** list of values */
  protected values: PossibleValueResource[]|undefined;

  public valueCtrl: FormControl = new FormControl();
  public filterCtrl: FormControl = new FormControl();
  /** list of values filtered by search keyword */
  public filteredValues: ReplaySubject<PossibleValueResource[]> = new ReplaySubject<PossibleValueResource[]>(1);
  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();

  @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;

  constructor(private orderPipe: OrderPipe) {}

  ngOnInit() {
    this.field.possibleValues = this.orderPipe.transform(this.field.possibleValues, 'name', false, true);
    this.values = this.field.possibleValues;
    if(this.values) {
      this.filteredValues.next(this.values.slice());
    }
    //this.valueCtrl.setValue(this.field.value);
    // listen for search field value changes
    this.filterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterValues();
      });

  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  compareValues(a: { [x: string]: any; }, b: { [x: string]: any; }) {
    return a['value'] === b['value'];
  }

  protected filterValues() {
    if (!this.values) {
      return;
    }
    // get the search keyword
    let search = this.filterCtrl.value;
    if (!search) {
      this.filteredValues.next(this.values.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the values
    this.filteredValues.next(
      this.values.filter(obj => (obj['name' as keyof typeof obj] as string).toLowerCase().indexOf(search) > -1)
    );
  }

}
